<template>
  <div class="page_main">
    <!--搜索区域-->
    <div class="search_block">
      <Form :label-width="90" inline>
        <FormItem label="机构名称">
          <Input placeholder="请输入" v-model="table.search.OrganName" clearable></Input>
        </FormItem>
        <FormItem label="机构编码">
          <Input placeholder="请输入" v-model="table.search.OrganCode" clearable></Input>
        </FormItem>
        <FormItem label="机构英文名">
          <Input placeholder="请输入" v-model="table.search.OrganNameEN" clearable></Input>
        </FormItem>
      </Form>
      <div>
        <Button class="mr-3" type="success" @click="search">查询</Button>
        <Button
          class="mr-3"
          type="primary"
          @click="toAdd"
          >新增</Button
        >
          <!-- v-has="'/organ/create'" -->
        <Button
          class="mr-3"
          type="warning"
          @click="deleteBatch"
          >批量删除</Button
        >
          <!-- v-has="'/organ/delete'" -->
      </div>
    </div>
    <!--列表区域-->
    <DataTable
      class="mb-5"
      ref="dataTable"
      :columns="table.columns"
      :apiUrl="table.apiUrl"
      :search="table.search"
      :width="500"
      @selectionChange="selectionChange"
    ></DataTable>

    <!--详细-->
    <Modal
      v-model="detailModal"
      title="机构详细"
      :footer-hide="true"
      
    >
      <organdetail
        :currentId="currentId"
        v-if="detailModal"
        @close="detailModal = false"
      ></organdetail>
    </Modal>
    <!--医院信息详细-->
    <Modal
      v-model="HospitaldetailModal"
      title="医院详细"
      :footer-hide="true"
      
    >
      <hospitaldetail
        :currentId="currentId"
        v-if="HospitaldetailModal"
        @close="HospitaldetailModal = false"
      ></hospitaldetail>
    </Modal>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable.vue";
import organdetail from "../organ/detail.vue";
import hospitaldetail from "../organ/hospitaldetail.vue";
export default {
  components: { DataTable, organdetail, hospitaldetail },
  data: function () {
    return {
      currentId: "",
      detailModal: false,
      HospitaldetailModal: false,
      selectionData: [],
      table: {
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "序号",
            key: "",
            type: "index",
            width: "60",
          },
          { title: "机构名称", key: "organName" },
          { title: "机构编码", key: "organCode" },
          { title: "机构英文名称", key: "organNameEN" },
          { title: "机构类型", key: "organType" },
          { title: "电话", key: "organTell" },
          {
            title: "操作",
            width: "260px",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.toDetail(params.row.organID);
                      },
                    },
                  },
                  "查看"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                      // display:
                      //   this.$common.tablebuttonPermission("/organ/update"),
                    },
                    on: {
                      click: () => {
                        this.toEdit(params.row);
                      },
                    },
                  },
                  "编辑"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#3795C8',
                    },
                    on: {
                      click: () => {
                        this.hospitaldetail(params.row.organID);
                      },
                    },
                  },
                  "医院信息"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small",
                    },
                    style: {
                      marginRight: "5px",
                      color:'#FA6266',
                      display:
                        this.$common.tablebuttonPermission("/organ/delete"),
                    },
                    on: {
                      click: () => {
                        this.deleteSingle(params.row.organID);
                      },
                    },
                  },
                  "删除"
                ),
              ]);
            },
          },
        ],
        apiUrl: "organ/getlist",
        search: {
          OrganCode: "",
          OrganName: "",
          OrganNameEN: "",
        },
      },
    };
  },

  created: function () {
  },
  activated(){
    this.search()
  },
  // watch: {
  //   $route:{
  //     handler(n){
	// 	// 初始化操作
  //   this.search()
  //   console.log('页面加载watch');
  //     },
  //     immediate: true,
  //     deep: true,
  //   }
  // },
  methods: {
    search: function () {
      
      this.$refs.dataTable.initload();
    },

    toDetail: function (id) {
      this.detailModal = true;
      this.currentId = id;
    },

    toAdd: function () {
      this.$router.push({ path: "organAdd" });
    },

    toEdit: function (data) {
      this.$router.push({ path: "organEdit", query: { id: data.organID } });
    },
    hospitaldetail: function (id) {
      
      this.HospitaldetailModal = true;
      this.currentId = id;
    },
    //单个删除
    deleteSingle: function (id) {
      this.$Modal.confirm({
        title: "确认要删除该机构？",
        mask: false,
        onOk: () => {
          this.$api.post(`/organ/deleteaa?id=${id}`).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("删除成功");
              this.search();
            }
          });
        },
      });
    },

    //批量删除
    deleteBatch() {
      if (this.selectionData.length < 1) {
        this.$Message.warning("请先勾选数据");
      } else {
        let ids = [];
        this.selectionData.forEach((item) => {
          ids.push(item.organID);
        });
        let _ids = ids.join(";");
        this.$Modal.confirm({
          title: "确认要批量删除选中的数据？",
          mask: false,
          onOk: () => {
            this.$api.post(`/organ/deleteBatch?ids=${_ids}`).then((rsp) => {
              if (rsp != false) {
                this.$Message.success("删除成功");
                this.search();
              }
            });
          },
        });
      }
    },

    //多选回调
    selectionChange(data) {
      this.selectionData = data;
    },
  },
};
</script>
